import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {ClassificacaoTributariaIBSCBS} from "./classificacao.tributaria.ibs.cbs";
import {VinculoNBSIndicadorOperacao} from "./vinculo.nbs.indicador.operacao";

@JacksonType("VinculoNBSIndicadorOperacaoClassificacaoTributaria")
@JsonIdentityInfo()
export class VinculoNBSIndicadorOperacaoClassificacaoTributaria extends SonnerBaseEntity {

  id: number;

  @JacksonType("VinculoNBSIndicadorOperacao")
  vinculoNBSIndicadorOperacao: VinculoNBSIndicadorOperacao;

  @JacksonType("ClassificacaoTributariaIBSCBS")
  classificacao: ClassificacaoTributariaIBSCBS

}
